const MONTH_KEY_PATTERN = /^(\d{4})-(0[1-9]|1[0-2])$/

const FUTURE_REPORT_MONTH_ERROR = "Reports cannot be generated for a future month or year."

const getCurrentMonthKey = (now = new Date()): string =>
  `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, "0")}`

const isFutureMonthKey = (monthKey: string, now = new Date()): boolean =>
  MONTH_KEY_PATTERN.test(monthKey) && monthKey > getCurrentMonthKey(now)

const getReportMonthGenerationError = (monthKey: string, now = new Date()): string | null => {
  if (!MONTH_KEY_PATTERN.test(monthKey)) return "The report month is invalid."
  if (isFutureMonthKey(monthKey, now)) return FUTURE_REPORT_MONTH_ERROR
  return null
}

export { FUTURE_REPORT_MONTH_ERROR, getCurrentMonthKey, getReportMonthGenerationError, isFutureMonthKey }
